import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'
import Home from '@/components/home/home'
import Message from '@/components/message/message'
import License from '@/components/license/license'
import LicenseMain from '@/components/license/components/licenseMain'
import licenseInfo from '@/components/license/components/licenseInfo'
import Drainage from '@/components/drainage/drainage'
import DrainageMain from '@/components/drainage/components/drainageMain'
import MessageMain from '@/components/message/components/messageMain'
import messageInfo from '@/components/message/components/messageInfo'
import newMessage from '@/components/message/components/newMessage'
import editMessage from '@/components/message/components/editMessage'
import Count from '@/components/count/count'
import CountMain from '@/components/count/components/countMain'
import notfount from '@/common/notFount'
import systemTurn from '@/common/systemTurn'
import SystemMain from '@/components/system/system'


Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/login',
      component: Home,
      children: [
        {
          path: 'message',
          name: 'Message',
          redirect: '/message/main',
          component: Message,
          meta: {
            breadcrumbName: "排水户信息管理"
          },
          children: [
            {
              path: 'main',
              name: 'MessageMain',
              component: MessageMain,
            },
            {
              path: 'info',
              name: 'messageInfo',
              component: messageInfo,
              meta: {
                breadcrumbName: "详情"
              },

            },
            {
              path: 'new',
              name: 'newMessage',
              component: newMessage,
              meta: {
                breadcrumbName: "新建"
              },

            },
            {
              path: 'edit',
              name: 'editMessage',
              component: editMessage,
              meta: {
                breadcrumbName: "编辑"
              },

            }
          ]
        },
        {
          path: 'license',
          name: 'License',
          redirect: '/license/main',
          component: License,
          meta: {
            breadcrumbName: "许可证勘察审批"
          },
          children: [
            {
              path: 'main',
              name: 'LicenseMain',
              component: LicenseMain,
            },
            {
              path: 'info',
              name: 'licenseInfo',
              component: licenseInfo,
              meta: {
                breadcrumbName: "详情"
              }
            },
            {
              path: 'edit',
              name: 'licenseEdit',
              component: licenseInfo,
              meta: {
                breadcrumbName: "编辑"
              }
            }
          ]
        },
        {
          path: 'drainage',
          name: 'Drainage',
          component: DrainageMain,
          meta: {
            breadcrumbName: "排水户检查"
          },
          children: [
            {
              path: 'DrainageMain',
              name: 'DrainageMain',
              component: DrainageMain,
            },
          ]
        },
        {
          path: 'count',
          name: 'Count',
          component: CountMain,
          meta: {
            breadcrumbName: "统计分析"
          },
          children: [
            {
              path: 'CountMain',
              name: 'CountMain',
              component: CountMain,
            },
          ]
        },
        {
          path: 'system',
          name: 'system',
          component: SystemMain,
          meta: {
            breadcrumbName: "配置管理"
          },
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/notfount',
      name: 'notfount',
      component: notfount
    },
    {
      path: '/systemTurn',
      name: 'systemTurn',
      component: systemTurn
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js